import { render, staticRenderFns } from "./ServiceBilling.vue?vue&type=template&id=4718bd4e&scoped=true"
import script from "./ServiceBilling.vue?vue&type=script&lang=js"
export * from "./ServiceBilling.vue?vue&type=script&lang=js"
import style0 from "./ServiceBilling.vue?vue&type=style&index=0&id=4718bd4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4718bd4e",
  null
  
)

export default component.exports